/*
 * @Author: Zhanglei
 * @Date: 2020-07-06 14:16:23
 * @LastEditTime: 2020-08-21 22:44:27
 * @LastEditors: Zhanglei
 * @Description: In User Settings Edit
 * @FilePath: /desktop/src/languages/en.js
 */

import enLocale from "element-ui/lib/locale/lang/en";

const en = {
  network: {
    permission: "The authentication session has expired. Please login again.",
    noNetWork: "The network is abnormal, please check your network",
    nowork: "There are too many current visitors, please try again later",
    error: "The current system is abnormal, please quit and try again"
  },
  header: {
    lang: "Language",
    logout: "Log Out",
    name: "BMW China TU"
  },
  button: {
    operation: "Operation",
    details: "Detail",
    orderDetails: "Order Detail",
    delete: "Delete",
    redact: "Modify",
    cancel: "Cancel",
    confirm: "Confirm",
    confirmDelete: "Confirm Deletion",
    confirmDeleteData: "Confirm Delete Data",
    confirmUpdate: "Batch Export",
    confirmUpdateData: "Confirm Export",
    // eslint-disable-next-line no-dupe-keys
    confirm: "Confirm",
    Reservation: "Reservation",
    pickCar: "Pickup the car",
    returnCar: "Return Car",
    AdditionalFee: "Additional Fee",
    RefundFee: "Refund Fee",
    ModifyPrice: "Modify Price",
    changeCar: "Transfer",
    Approve: "Approve",
    pass: "Pass",
    submit: "Submit",
    return: "Return",
    Refuse: "Refuse",
    Import: "Batch Import",
    download: "Download All",
    returnL: "Return"
  },
  list: {
    delete: 'Delete',
    tips: 'Tips',
    determine: 'Determine',
    cancel: 'Cancel',
    deletionCancelled: 'Deletion Cancelled',
    batchDeletion: 'Batch deletion',
    confirmDelete: "Confirm Deletion",
    pleaseSelectTheDataToDelete: 'Please select the data to delete'
  },
  login: {
    sysname: "Sysname",
    passwordlogin: "Account login",
    account: "Account",
    password: "Password",
    verificationcode: "Verification Code",
    forgetpassword: "Forget Password",
    registeraccount: "Register Account",
    help: "Help",
    enter: "Enter",
    privacy: "Privacy",
    terms: "Terms",
    scanningcode: "QR login",
    openjoychat: "Open JoyChat",
    prompt_code: "Please enter verification code!",
    prompt_account: "Please fill in the account!",
    prompt_pass: "Please fill in the password!",
    error_pass: "Incorrect username or password!",
    error_login: "Login failed!",
    scanningcodelogin:
      "After scanning the code, click 'Confirm Authorization' to complete the account login",
    // eslint-disable-next-line no-dupe-keys
    help: "Help",
    // eslint-disable-next-line no-dupe-keys
    privacy: "Privacy",
    // eslint-disable-next-line no-dupe-keys
    terms: "Terms"
  },
  table: {
    conditionsQuery: "Conditionsquery",
    dataSort: "Datasort",
    configurationColumn: "ConfigurationColumn",
    newData: "New",
    deleteData: "Delete",
    confirmDeleteData: "Confirm Delete",
    confirmUpdate: "Batch Export",
    confirmUpdateData: "Confirm Export",
    deriveData: "Derive",
    refreshData: "Refresh",
    more: "More",
    queryData: "Query",
    resetAll: "Reset all",
    packUp: "Pack up",
    account: "Account",
    id: "ID",
    authType: "Certification Type",
    creator: "Creator",
    createdAt: "Created",
    updatedAt: "Updated",
    lastLoginTime: "Last Login Time",
    isForbidden: "Isforbidden",
    AddToGroup: "Add to group",
    AddToUnit: "Add to unit",
    AddToRole: "Add to role",
    isEnabled: "Isenabled",
    start: "Start",
    end: "End",
    user: {
      name: "name"
    }
  },
  role: {
    id: "ID",
    name: "Name",
    code: "Code",
    createdAt: "Created Date",
    updatedAt: "Updated Date"
  },
  template: {
    id: "ID",
    name: "Name",
    version: "Version",
    route: "Route",
    createdAt: "CreatedAt",
    operating: "Operating",
    createTitle: "Create Template",
    grid: "Template",
    enter: "Please Enter"
  },
  unit: {
    id: "ID",
    name: "Name",
    code: "Code",
    path: "Path",
    level: "Level",
    parentId: "Parent Id",
    createdAt: "Created Date",
    updatedAt: "Updated Date"
  },
  menu: {
    id: "ID",
    name: "Name",
    type: "Type",
    icon: "ICON",
    path: "Path",
    route: "Route",
    level: "Level",
    parentId: "Parent Id",
    template: "Template",
    createdAt: "Created Date",
    updatedAt: "Updated Date"
  },
  user: {
    id: "ID",
    name: "Name",
    jobNumber: "Job Number",
    gender: "Gender",
    department: "Department Name",
    idType: "ID Type",
    idNumber: "ID Number",
    mobile: "Mobile",
    telephone: "Telephone",
    email: "E-Mail",
    dimission: "Dimission",
    address: "Address",
    createdAt: "Created Date",
    syncedAt: "Synced Date",
    updatedAt: "Updated Date",
    displayName: "Display Name",
    firstName: "First Name",
    lastName: "Last Name",
    birthName: "Birth Name",
    title: "Title",
    leader: "Leader",
    departmentCode: "Department Code"
  },
  dialog: {
    createTitle: "Create",
    editTitle: "Modify",
    deleteTitle: "Delete",
    infoTitle: "Detail",
    returnCar: "Return Car",
    pickCar: "Pickup Car",
    AdditionalTitle: "Additional Fee",
    returnTitle: "Refund Fee",
    ModifyPrice: "Modify Price"
  },
  group: {
    id: "ID",
    name: "Name",
    code: "Code",
    type: "Type",
    createdAt: "Created Date",
    syncedAt: "Synced Date",
    updatedAt: "Updated Date"
  },
  carGroup: {
    id: "ID",
    name: "Name",
    region: "Region",
    fleets: "Fleet",
    createdAt: "Created Date",
    syncedAt: "Synced Date",
    updatedAt: "Updated Date"
  },
  endpoint: {
    id: "ID",
    name: "Name",
    createdAt: "Created Date",
    syncedAt: "Synced Date",
    updatedAt: "Updated Date",
    uri: "URI"
  },
  action: {
    id: "ID",
    name: "Name",
    code: "Code",
    description: "Description",
    menu: "Menu",
    createdAt: "Created Date",
    syncedAt: "Synced Date",
    updatedAt: "Updated Date"
  },
  config: {
    id: "ID",
    name: "Name",
    createdAt: "Created Dates",
    category: "Category",
    key: "Type",
    value: "Value",
    isPublic: "Public",
    updatedAt: "Updated Date"
  },
  domain: {
    id: "ID",
    name: "Name",
    createdAt: "Created Date",
    syncedAt: "Synced Date",
    updatedAt: "Updated Date"
  },
  // eslint-disable-next-line no-dupe-keys
  menu: {
    id: "ID",
    name: "Name",
    type: "Type",
    icon: "ICON",
    path: "Path",
    route: "Route",
    level: "Level",
    parentId: "Parent Id",
    template: "Template",
    createdAt: "Created Date",
    syncedAt: "Synced Date",
    updatedAt: "Updated Date"
  },
  permission: {
    id: "ID",
    name: "Name",
    code: "Code",
    createdAt: "Created Date",
    updatedAt: "Updated Date"
  },
  message: {
    createSuccess: "Created Successfully!",
    editSuccess: "Edit Successfully!",
    deleteSuccess: "Successfully Deleted!",
    returnSuccess: "Return the car successfully!",
    pickSuccess: "Pickup the car successfully!",
    ApproveSuccess: "Approved successfully!"
  },
  handover: {
    orderNumber: "Order Number",
    carName: "Order Name",
    createdAt: "Created",
    updatedAt: "Updated",
    startDate: "Pickup Date",
    endDate: "Return Date",
    note: "Note",
    plateNumber: "Plate Number",
    status: "Status",
    userName: "User Name",
    userPhone: "User Phone",
    fetchNote: "Pickup Notes",
    returnNote: "Return Notes",
    startMiles: "Pickup kilometers",
    endMiles: "Return kilometers",
    driverLicenseNumber: "DriverLicenseNumber"
  },
  tableTemplate: {
    tableTitleList: [
      {
        name: "account",
        content: "账号",
        type: "1",
        id: "2212xxxxx",
        screening: true
      },
      {
        name: "id",
        content: "用户ID",
        type: ""
      }
    ]
  },
  vehicle: {
    name: "Name(EN)",
    nameL1: "Name(ZH)",
    carGroup: "Group",
    plateNumber: "Plate Num",
    plateType: "Plate Type(EN)",
    plateTypeL1: "Plate Type(CN)",
    engine: "Engine(EN)",
    engineL1: "Engine(CN)",
    transmission: "Transmission(EN)",
    transmissionL1: "Transmission(CN)",
    seats: "Seats(EN)",
    seatsL1: "Seats(CN)",
    color: "Color(EN)",
    colorL1: "Color(CN)",
    capacity: "Capacity",
    plateDate: "Plate Date",
    img: "Image URL",
    vin: "Vin",
    fleet: "Fleet",
    initialMiles: "Initial KM",
    luggageCapacity: "Luggage Capacity",
    brand: "Brand",
    model: "Model",
    region: "Regions",
    site: "Service Site",
    initialDate: "Initial Date",
    isEnabled: "Status",
    createdAt: "Created",
    updatedAt: "Updated"
  },
  order: {
    orderNumber: "ID",
    carName: "Order Name",
    createdAt: "Created",
    updatedAt: "Updated",
    startDate: "Pickup Date",
    updateDate: "Updated",
    jobNumber: "Job Number",
    siteName: "Service Site",
    orderPrice: "Order Price",
    finalPrice: "Final Price",
    status: "Status",
    fetchNote: "Pickup Notes",
    returnNote: "Return Notes",
    userPhone: "Tenant Phone",
    userName: "Tenant Name",
    driverLicenseNumber: "Driver's license number",
    siteContact: "Service site contact",
    siteAddress: "Service site address",
    sitePhone: "Telephone",
    note: "Remarks",
    ApplyForApproval: "Apply For Approval"
  },
  goods: {
    type: "Type",
    title: "Product Name",
    pricePackage: "Price Package",
    carGroupId: "Car Group",
    validStartTime: "Booking Start Date",
    validEndTime: "Booking End Date",
    imageUrl: "Event Banner URL",
    desc: "Event Detail Image URL(EN)",
    descL1: "Event Detail Image URL(ZH)",
    startDate: "Event Start Date",
    endDate: "Event End Date",
    createdAt: "Created",
    subType: "SubType",
    updatedAt: "Updated",
    userPhone: "Tenant phone",
    userName: "Tenant name",
    driverLicenseNumber: "Renter's license number",
    siteContact: "Service site contact",
    siteAddress: "Service site address",
    sitePhone: "phone",
    year: "Year",
    region: "Region",
    price: "Price",
    fleets: "Fleets",
    punishDays: "Early cancellation time (day)",
    punishDiscount: "Handling Fee (%)",
    customerType: "Customer",
    rentalCompany: "RentalCompany",
    note: "Remarks for pickup and return"
  },
  price: {
    title: "Price Name",
    employeePrice: "BMW Employee Prices",
    supplierPrice: "Partner Price",
    dealerPrice: "Dealer Price",
    createdAt: "createdAt",
    type: "reason",
    updatedAt: "updatedAt"
  },
  region: {
    name: "AreaName(EN)",
    nameL1: "AreaName(CN)",
    id: "ID",
    isEnabled: "isEnabled",
    createdAt: "createdAt",
    updatedAt: "updatedAt"
  },
  feeAudit: {
    id: "Id",
    orderNumber: "orderNumber",
    createAt: "createdAt",
    updatedAt: "updatedAt",
    orderPrice: "OrderPrice",
    birthName: "BirthName",
    jobNumber: "JobNumber",
    department: "Department",
    birthCode: "BirthCode",
    PickLocation: "Pick up location",
    signature: "Signature",
    gender: "Gender",
    mobile: "Mobile",
    Entry: "Entry Date",
    Birth_photo: "Birth certificate photo",
    stateId: "State",
    type: "Type",
    reason: "Reason",
    price: "Price",
    updater: "Updater",
    pendingR: "Pending",
    pending: "Unclaimed",
    Received: "Received",
    rejected: "Rejected",
    closed: "Closed",
    pass: "Pass",
    Expired: "Expired",
    start: "Start",
    end: "End",
    creater: "Creater",
    ascending: "Ascending",
    descending: "Descending",
    email:'Email'
  },
  newlyMarried: {
    id: "Id",
    orderNumber: "orderNumber",
    createAt: "createdAt",
    updatedAt: "updatedAt",
    orderPrice: "OrderPrice",
    birthName: "BirthName",
    jobNumber: "JobNumber",
    department: "Department",
    newlyMarriedCode: "Marriage Certificate Number",
    PickLocation: "Pick up location",
    signature: "Signature",
    gender: "Gender",
    mobile: "Mobile",
    Entry: "Entry Date",
    newlyMarried_photo: "Marriage Certificate photo",
    stateId: "State",
    type: "Type",
    reason: "Reason",
    price: "Price",
    updater: "Updater",
    pendingR: "Pending",
    pending: "Unclaimed",
    Received: "Received",
    rejected: "Rejected",
    closed: "Closed",
    pass: "Pass",
    Expired: "Expired",
    start: "Start",
    end: "End",
    creater: "Creater",
    ascending: "Ascending",
    descending: "Descending",
    receiveType: "Collection method",
    bySelf: "By self",
    byMail: "By mail"
  },
  "union":{
    name: "BirthName",
    birthName: "BirthName",
    jobNumber: "JobNumber",
    department: "Department",
    approval: "Approval Date",
    createAt: "Apply Date",
    applyAt: "Apply Date",
    hireDate: "Hire Date",
    stateId: "Status",
    start: "Start",
    end: "End",
    pending: "Pending",
    rejected: "Rejected",
    noPay: "unPaid",
    paid: "Paid",
    approved: "Approved",
    ascending: "Ascending",
    descending: "Descending",
    uploadBtn: "Batch Import Approval Results",
    tip: "Please enter the reason for rejection",
    confirm: "Confirm",
    uploadError: "Upload Failed",
    uploadSuccess: "Upload Successfully",
    dimission: "On the job",
    onJob: "Working",
    noJob: "Leaving",
    personnelSubarea: "Personnel Subarea",
    fromBbaOther: "From BMW Other",
    yes: "Yes",
    no: "No",
    email: "Email"
  },
  "excelError":{
    "title": "Download Tips",
    "okText": "Continue to export report",
    "tip": "According to BMW's information security policy, this data involves personal sensitive information. Please complete the approval and authorization first.",
    "checkboxText": "I have completed the approval and obtained the authorization to operate the data. I strictly abide by the BMW information security policy.",
    "error": "Please select the data to download"
  },
  welfare: {
    id: "Id",
    name: "Benefit Name(CN)",
    name1: "Benefit Name",
    startAt: "Start date",
    endAt: "End date",
    state: "State",
    pending: "Pending",
    progress: "In Progress",
    over: "Is Over",
    toBeAvailable: "To Be Available",
    isOnSale: "isOnSale",
    enName: "Benefit Name(EN)",
    listM: "List Mgt",
    MessageName: "Please fill in the name of the benefit (CN)!",
    MessageEnName: "Please fill in the name of the benefit (EN)!",
    MessageStartAt: "Please choose a start time!",
    MessageEndAt: "Please select the end time!",
    MessageAt: "The selected start time must be less than the end time!",
    MessageDelete: "Please select the person to be deleted!",
    createAt: "createAt",
    updatedAt: "updatedAt",
    jobNumber: "Jobnumber",
    department: "Department",
    birthName: "BerthName",
    signatureThumbnails: "Signature",
    comment: "Comment",
    pendingConfirm: "To Be Confirmed",
    Confirmed: "Confirmed",
    expired: "Expired",
    unaccalimed: "Unclaimed",
    exportUnclaimed: "Export Unclaimed"
  },
  ...enLocale
};

export default en;



// WEBPACK FOOTER //
// ./src/languages/en.js